import Sidemenu from "../layout/sidemenu";
import Header from "../layout/header";
import React, { useState } from "react";

const Dashboard = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    return (
        <>
            <div className={`workspace-wrapper ${isCollapsed ? "collapsed" : ""}`}>
                <Sidemenu />
                <div className="workspace">
                    <Header toggleCollapse={() => setIsCollapsed(!isCollapsed)} />
                    <div className="workspace-content"></div>
                </div>
            </div>
        </>
    )
}

export default Dashboard;